export default function Machines_C_8 (number = 1) {
  return {
    name: '星际物流运输站',
    icon: '/static/img/machines/c8.png',
    number
  }
}



// WEBPACK FOOTER //
// ./src/components/Machines_C/Machines_C_8.js